import { motion } from "framer-motion";
import { MapPin, Clock, Phone } from "lucide-react";
import {
  useSiteContent,
  useWeeklyHours,
  formatDayHours,
  DAYS,
} from "./siteContent";

export default function LocationSection() {
  const site = useSiteContent();
  const weekly = useWeeklyHours();
  return (
    <section
      data-testid="location-section"
      className="border-t border-[#102C1F]/15 bg-[#EDE8DE]"
    >
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-24 md:grid-cols-[1fr_1.3fr] md:px-10 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col justify-center"
        >
          <h2 className="font-display text-4xl italic tracking-tight sm:text-5xl">
            {site.location_title1}
            <br />
            {site.location_title2}
          </h2>
          <div className="mt-10 space-y-6 text-sm text-[#102C1F]/75">
            <div data-testid="location-address" className="flex items-start gap-3">
              <MapPin size={18} className="mt-1 shrink-0" />
              <p>
                <span className="font-display text-xl italic tracking-tight text-[#102C1F] md:text-2xl">
                  {site.location_name}
                </span>
                <br />
                {site.location_address}
              </p>
            </div>
            <div className="flex items-start gap-3">
              <Clock size={18} className="mt-0.5 shrink-0" />
              <div className="space-y-1">
                {DAYS.map(([key, label]) => (
                  <p key={key}>
                    <span className="font-medium text-[#102C1F]">
                      {label.slice(0, 3)}.
                    </span>{" "}
                    {formatDayHours(weekly[key])}
                  </p>
                ))}
              </div>
            </div>
            <p className="flex items-start gap-3">
              <Phone size={18} className="mt-0.5 shrink-0" />
              {site.location_phone}
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="overflow-hidden rounded-sm border border-[#102C1F]/15 shadow-[0_30px_60px_-30px_rgba(16,44,31,0.35)]"
        >
          <iframe
            data-testid="location-map"
            title="Mapa — J'aime la vie"
            src={site.location_map}
            loading="lazy"
            className="h-[420px] w-full border-0 grayscale-[35%]"
          />
        </motion.div>
      </div>
    </section>
  );
}
